module.exports = __webpack_public_path__ + "static/media/ashoka-logo.ffc6f345.png";